<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17etSkB/tc-custom/9780369702654.jpg?1743828576360" alt="This image is the cover for the book Wedding Secret"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wedding Secret
      </h1>
      <p class="bookDescription body article font2">
        <b>A chance encounter with a handsome groomsman turns into so much more for a newly single wedding florist in this romantic reader-favorite story from Kianna Alexander!</b><br/><br/>After discovering her fiancé’s public and utterly embarrassing infidelity, florist Renata McPherson is left dateless to her beloved client’s nuptials. But meaningful eye contact with one devastatingly handsome groomsman leaves Renata unexpectedly breathless…<br/><br/>As a contractor, Amir Robertson has quite the knack for design. Though he has no plans for rebuilding the gorgeous shop owner’s heart…at first. Their no-strings-attached arrangement could soon fail when a secret that joins them forever is revealed.<br/><br/><i>Previously published.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kianna Alexander
      </h2>
      
      <p class="authorDescription body article">Like any good Southern belle, Kianna Alexander wears many hats: doting mama, advice-dispensing sister, and gabbing girlfriend. She&#39;s a voracious reader, an amateur seamstress and occasional painter in oils. Chocolate, American history, sweet tea, and Idris Elba are a few of her favorite things. &#160;A native of the TarHeel state, Kianna still lives there with her husband, two kids, and a collection of well-loved vintage 80&#39;s Barbie dolls.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?00e07859